/* eslint-disable  */
import { UnityContext } from "react-unity-webgl";

const defaultState = () => {
  var context = new UnityContext({
    loaderUrl: "unity_game/Build/unity_game.loader.js",
    dataUrl: "unity_game/Build/unity_game.data.unityweb",
    frameworkUrl: "unity_game/Build/unity_game.framework.js.unityweb",
    codeUrl: "unity_game/Build/unity_game.wasm.unityweb",
  });
  return context;
}

const reducer = function (state = defaultState(), action) {
  switch (action.type) {
    default:
      return state;
  }
};

export { reducer as default };
